/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './service';
import './card_management';
import './unified_activity';
import './transaction_dispute';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "externalservice": {
            "nested": {
              "GetEnabledRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetEnabledResponse": {
                "fields": {
                  "isEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ExternalBizbankService": {
                "methods": {
                  "CheckIdentityVerificationStatus": {
                    "requestType": ".squareup.bizbank.service.CheckIdentityVerificationStatusRequest",
                    "responseType": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse"
                  },
                  "ConfirmIssueCard": {
                    "requestType": ".squareup.bizbank.service.ConfirmIssueCardRequest",
                    "responseType": ".squareup.bizbank.service.ConfirmIssueCardResponse"
                  },
                  "CreateCardCustomization": {
                    "requestType": ".squareup.bizbank.service.CreateCardCustomizationRequest",
                    "responseType": ".squareup.bizbank.service.CreateCardCustomizationResponse"
                  },
                  "CreateUserAuthorization": {
                    "requestType": ".squareup.bizbank.card_management.CreateUserAuthorizationRequest",
                    "responseType": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse"
                  },
                  "DeactivateCard": {
                    "requestType": ".squareup.bizbank.service.DeactivateCardRequest",
                    "responseType": ".squareup.bizbank.service.DeactivateCardResponse"
                  },
                  "FinishCardActivation": {
                    "requestType": ".squareup.bizbank.service.FinishCardActivationRequest",
                    "responseType": ".squareup.bizbank.service.FinishCardActivationResponse"
                  },
                  "GetBalance": {
                    "requestType": ".squareup.bizbank.service.GetBalanceRequest",
                    "responseType": ".squareup.bizbank.service.GetBalanceResponse"
                  },
                  "GetBalanceOverview": {
                    "requestType": ".squareup.bizbank.unified_activity.GetBalanceOverviewRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetBalanceOverviewResponse"
                  },
                  "GetPaymentProcessingDetails": {
                    "requestType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse"
                  },
                  "GetUnifiedActivities": {
                    "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse"
                  },
                  "GetUnifiedActivityDetails": {
                    "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest",
                    "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse"
                  },
                  "GetCardActivity": {
                    "requestType": ".squareup.bizbank.service.GetCardActivityRequest",
                    "responseType": ".squareup.bizbank.service.GetCardActivityResponse"
                  },
                  "GetCardCustomization": {
                    "requestType": ".squareup.bizbank.service.GetCardCustomizationRequest",
                    "responseType": ".squareup.bizbank.service.GetCardCustomizationResponse"
                  },
                  "GetCustomizationSettings": {
                    "requestType": ".squareup.bizbank.service.GetCustomizationSettingsRequest",
                    "responseType": ".squareup.bizbank.service.GetCustomizationSettingsResponse"
                  },
                  "GetAllStamps": {
                    "requestType": ".squareup.bizbank.service.GetAllStampsRequest",
                    "responseType": ".squareup.bizbank.service.GetAllStampsResponse"
                  },
                  "GetEnabled": {
                    "requestType": ".squareup.bizbank.externalservice.GetEnabledRequest",
                    "responseType": ".squareup.bizbank.externalservice.GetEnabledResponse"
                  },
                  "GetPrivateCardData": {
                    "requestType": ".squareup.bizbank.card_management.GetPrivateCardDataRequest",
                    "responseType": ".squareup.bizbank.card_management.GetPrivateCardDataResponse"
                  },
                  "GetTransactionDisputeActivity": {
                    "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse"
                  },
                  "ListCards": {
                    "requestType": ".squareup.bizbank.service.ListCardsRequest",
                    "responseType": ".squareup.bizbank.service.ListCardsResponse"
                  },
                  "ListTransactionDisputes": {
                    "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest",
                    "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse"
                  },
                  "ProvideFeedback": {
                    "requestType": ".squareup.bizbank.service.ProvideFeedbackRequest",
                    "responseType": ".squareup.bizbank.service.ProvideFeedbackResponse"
                  },
                  "SetEnabled": {
                    "requestType": ".squareup.bizbank.service.SetEnabledRequest",
                    "responseType": ".squareup.bizbank.service.SetEnabledResponse"
                  },
                  "SetPasscode": {
                    "requestType": ".squareup.bizbank.service.SetPasscodeRequest",
                    "responseType": ".squareup.bizbank.service.SetPasscodeResponse"
                  },
                  "StartCardActivation": {
                    "requestType": ".squareup.bizbank.service.StartCardActivationRequest",
                    "responseType": ".squareup.bizbank.service.StartCardActivationResponse"
                  },
                  "StartIdentityVerification": {
                    "requestType": ".squareup.bizbank.service.StartIdentityVerificationRequest",
                    "responseType": ".squareup.bizbank.service.StartIdentityVerificationResponse"
                  },
                  "StartIssueCard": {
                    "requestType": ".squareup.bizbank.service.StartIssueCardRequest",
                    "responseType": ".squareup.bizbank.service.StartIssueCardResponse"
                  },
                  "StartTwoFactorAuthentication": {
                    "requestType": ".squareup.bizbank.service.StartTwoFactorAuthenticationRequest",
                    "responseType": ".squareup.bizbank.service.StartTwoFactorAuthenticationResponse"
                  },
                  "ToggleCard": {
                    "requestType": ".squareup.bizbank.service.ToggleCardRequest",
                    "responseType": ".squareup.bizbank.service.ToggleCardResponse"
                  },
                  "ValidateAddress": {
                    "requestType": ".squareup.bizbank.service.ValidateAddressRequest",
                    "responseType": ".squareup.bizbank.service.ValidateAddressResponse"
                  },
                  "VerifyCardActivationToken": {
                    "requestType": ".squareup.bizbank.service.VerifyCardActivationTokenRequest",
                    "responseType": ".squareup.bizbank.service.VerifyCardActivationTokenResponse"
                  },
                  "VerifyTwoFactorAuthenticationToken": {
                    "requestType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest",
                    "responseType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse"
                  },
                  "GetCardBillingAddress": {
                    "requestType": ".squareup.bizbank.service.GetCardBillingAddressRequest",
                    "responseType": ".squareup.bizbank.service.GetCardBillingAddressResponse"
                  },
                  "SetCardBillingAddress": {
                    "requestType": ".squareup.bizbank.service.SetCardBillingAddressRequest",
                    "responseType": ".squareup.bizbank.service.SetCardBillingAddressResponse"
                  },
                  "UpdateMerchantBlock": {
                    "requestType": ".squareup.bizbank.service.UpdateMerchantBlockRequest",
                    "responseType": ".squareup.bizbank.service.UpdateMerchantBlockResponse"
                  },
                  "GetMerchantBlock": {
                    "requestType": ".squareup.bizbank.service.GetMerchantBlockRequest",
                    "responseType": ".squareup.bizbank.service.GetMerchantBlockResponse"
                  },
                  "ListMerchantBlocks": {
                    "requestType": ".squareup.bizbank.service.ListMerchantBlocksRequest",
                    "responseType": ".squareup.bizbank.service.ListMerchantBlocksResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.GetEnabledRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.GetEnabledResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.ExternalBizbankService) {
	$root.addJSON(jsonData);
}

/**
 * This file includes external versions of endpoints from service.proto. Please see service.proto
 * for their specifications.
 *
 * SOURCE GetEnabledRequest @ squareup/bizbank/externalservice.proto at 20:1
 */
export const GetEnabledRequest = $root.lookupType('squareup.bizbank.externalservice.GetEnabledRequest');
fixType(GetEnabledRequest, {
  unitToken: { required: true },
});
Builder.createAndAttachToType(GetEnabledRequest);
/**
 * SOURCE GetEnabledResponse @ squareup/bizbank/externalservice.proto at 24:1
 */
export const GetEnabledResponse = $root.lookupType('squareup.bizbank.externalservice.GetEnabledResponse');
fixType(GetEnabledResponse, {
  isEnabled: { required: true },
});
Builder.createAndAttachToType(GetEnabledResponse);
/**
 * SOURCE ExternalBizbankService @ squareup/bizbank/externalservice.proto at 28:1
 */
export const ExternalBizbankService = $root.lookupService('squareup.bizbank.externalservice.ExternalBizbankService');
